import { CartValidation, CreateOrderPayload, Order } from "@/types/order";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
export const orderApi = createApi({
  reducerPath: "orderApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_API_BASE_URL}`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("access_token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Order"],
  endpoints: (builder) => ({
    createOrder: builder.mutation<Order, CreateOrderPayload>({
      query: (body) => ({
        url: "/api/v1/order/",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Order"],
    }),
    addDiscount: builder.mutation<
      {
        discount_value: string;
        discount_code: string;
        message: string;
        promotion_id: number;
        promotion_name: string;
      },
      {
        cart_items: any[];
        discount_code?: string;
        branch_id: string | null;
      }
    >({
      query: (body) => ({
        url: "/discount/promotion/apply-discount/",
        method: "POST",
        body,
      }),
    }),
    fetchOrders: builder.query<
      {
        count: number;
        next: string | null;
        previous: string | null;
        results: Order[];
      },
      {
        customer: string;
        page_size: number;
        payment_status: string;
        page: number;
        branch: string;
        pageSize: number;
      }
    >({
      query: ({
        customer,
        page_size,
        payment_status,
        page,
        branch,
        pageSize,
      }) =>
        `/api/v1/order?customer=${customer}&page_size=${page_size}&payment_status=${payment_status}&page=${page}&branch=${branch}&pageSize=${pageSize}`,
    }),
    getOrderDetails: builder.query<Order, { id: number }>({
      query: ({ id }) => `/api/v1/order/${id}`,
    }),
    calculateDeliveryFees: builder.mutation<
      { fees: string | number; address_id: number },
      {
        branch_id?: number;
        origin_address?: string;
        address?: string;
        city?: string;
        region?: string;
        country?: string;
        postal?: string;
      }
    >({
      query: (body) => ({
        url: "/api/calculate-delivery-fees/",
        method: "POST",
        body,
      }),
    }),
    validateCart: builder.mutation<{ message: string }, CartValidation>({
      query: (body) => ({
        url: "/api/v1/order/validate_order/",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useCreateOrderMutation,
  useAddDiscountMutation,
  useFetchOrdersQuery,
  useGetOrderDetailsQuery,
  useCalculateDeliveryFeesMutation,
  useValidateCartMutation,
} = orderApi;
